import { AppError } from "../../../shared/utils/error-handler";
import type { BusinessClientRepository } from "../../repositories/company/business-client-repository";
import type {
  BusinessClient,
  BusinessClientDetail,
  OrderFile,
} from "../../types/business-client";
import type { PageResponse } from "../../../shared/types/api";

export class BusinessClientUseCase {
  constructor(private repository: BusinessClientRepository) {}

  async getBusinessClients(
    companyId: number,
    keyword?: string,
    page?: number,
    size?: number,
  ): Promise<PageResponse<BusinessClient>> {
    try {
      return await this.repository.getBusinessClients(companyId, keyword, page, size);
    } catch (error) {
      throw new AppError(
        String(error) || "기업고객 목록을 불러오지 못했습니다.",
        "BUSINESS_CLIENT_LIST_FAILED",
        error,
      );
    }
  }

  async getBusinessClientDetail(
    companyId: number,
    userId: number,
  ): Promise<BusinessClientDetail> {
    try {
      return await this.repository.getBusinessClientDetail(companyId, userId);
    } catch (error) {
      throw new AppError(
        String(error) || "기업고객 상세 정보를 불러오지 못했습니다.",
        "BUSINESS_CLIENT_DETAIL_FAILED",
        error,
      );
    }
  }

  async getBusinessClientOrders(
    companyId: number,
    userId: number,
    params?: { status?: string; dateFrom?: string; dateTo?: string; page?: number; size?: number },
  ): Promise<PageResponse<any>> {
    try {
      return await this.repository.getBusinessClientOrders(companyId, userId, params);
    } catch (error) {
      throw new AppError(
        String(error) || "기업고객 주문내역을 불러오지 못했습니다.",
        "BUSINESS_CLIENT_ORDERS_FAILED",
        error,
      );
    }
  }

  async getBusinessClientOrderFiles(
    companyId: number,
    userId: number,
    page?: number,
    size?: number,
  ): Promise<PageResponse<OrderFile>> {
    try {
      return await this.repository.getBusinessClientOrderFiles(companyId, userId, page, size);
    } catch (error) {
      throw new AppError(
        String(error) || "기업고객 주문 파일 목록을 불러오지 못했습니다.",
        "BUSINESS_CLIENT_ORDER_FILES_FAILED",
        error,
      );
    }
  }
}